module.exports = __webpack_public_path__ + "static/media/tarjeta_american.307b69a6.svg";